import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Button,
  Grid,
  Modal,
  ListaEncerramentoExigencias,
  Input,
  DataGridCustom,
} from '../../../components/index';
import {
  doPut,
  requestExigencias,
  requestMotivos,
} from '../../../utils/requests';
import { tiposExigenciaSistema } from '../../../utils/constants';
import UploadDragDrop from '../../../components/ComponentesBasicos/UploadDragDrop';

class ModalEncerramentoExigencia extends Component {
  constructor(props) {
    super(props);
    const state = this.getInitialState();
    if (props.requerimento) {
      state.requerimento = props.requerimento;
    }
    this.state = state;
  }

  getInitialState = () => {
    const initialState = {
      requerimento: {
        exigencias: [],
      },
      arquivo: {
        documento: null,
        protocolo: null,
        tipoDocumento: null,
      },
      documents: [],
      document: null,
      tiposDisponiveis: [],
      tipoDocumento: null,
    };
    return initialState;
  }

  componentDidMount() {
    this.buscaDadosDeDominio();
    this.montaListaDocumentosDisponiveis();
  }

  componentDidUpdate(prevProps) {
    // Preenche requerimento se requerimento for alterado
    if (this.props.requerimento &&
      this.props.requerimento.protocolo !== prevProps.requerimento.protocolo) {
      this.atualizaRequerimento();
    }
  }

  montaListaDocumentosDisponiveis = () => {
    const lista = this.montarListaDocumentosAdicionais(this.props.requerimento);
    this.setState({
      tiposDisponiveis: lista,
    });
  }

  montarListaDocumentosAdicionais = (paramLista) => {
    let lista = paramLista;
    const tiposDocumentos = this.props.tiposDocumentos ? this.props.tiposDocumentos : [];
    const codigos = [22];
    lista = tiposDocumentos.filter(doc => (codigos.includes(doc.value)));
    return lista;
  }

  atualizaRequerimento = () => {
    const { requerimento } = { ...this.props };
    this.setState({ ...this.state, requerimento });
  }

  trataSucessoResponseEnvio = () => {
    this.props.handleEncerramentoExigenciaSent();
  }

  trataErrosResponse = (error) => {
    // eslint-disable-next-line
    const { requerimento } = { ...this.state };
    if (error.data.codigo === 4500) {
      // const colecao = ['showEncerramentoExigenciaModal', 'showModalAlertaRequerPerConcomitancia'];
      const chave = error.data.chaveConfirmacao;
      if (error.data.alertas && error.data.alertas.length > 0) {
        error.data.alertas.forEach((item) => {
          if (item.codigo === 4513) {
            this.props.handleModalComposto('showEncerramentoExigenciaModal', item.descricao, requerimento, chave);
          }
        });
      }
    }
  }

  handleSave = () => {
    const { requerimento, tipoDocumento, document } = { ...this.state };
    requerimento.estado = 3;
    let url = `requerimentos-compensacao-pensao/${requerimento.protocolo}`;
    if (requerimento.tipoAposentadoria) {
      url = `requerimentos-compensacao-aposentadoria/${requerimento.protocolo}`;
    }
    if (tipoDocumento && document) {
      this.addArquivo();
    }
    doPut(url, requerimento, this.trataSucessoResponseEnvio, this.trataErrosResponse);
  }

  filtraExigencias = () => {
    if (this.props.requerimento.exigencias) {
      return this.props.requerimento.exigencias
        .filter(exigencia => (!tiposExigenciaSistema.includes(exigencia.tipo)));
    }
    return '';
  }

  handlePositionalChange = (changeObj, name, tipoExigencia, codigoDependente) => {
    // console.log(tipoExigencia);
    const listaExigenciasModificada = this.state.requerimento.exigencias.map((exigencia, index) => {
      if (tipoExigencia === exigencia.tipo && (codigoDependente === exigencia.codigoDependente)) {
        const exigenciaAlterada = this.state.requerimento.exigencias[index];
        exigenciaAlterada[name] = changeObj.value;
        let atendida = 0;
        if (exigenciaAlterada.motivoNaoAtendimento !== 0 || exigenciaAlterada.comentarioNaoAtendimento !== '') {
          atendida = 2;
        }
        exigenciaAlterada.atendida = atendida;
        return exigenciaAlterada;
      }
      return this.state.requerimento.exigencias[index];
    });
    this.setState({
      requerimento: {
        ...this.state.requerimento,
        exigencias: listaExigenciasModificada,
      },
    });
  }

  doRequest = (typeRequest) => {
    switch (typeRequest) {
      case 'exigencia':
        if (this.props.exigencias.length === 0) {
          requestExigencias(this.failCallback);
        }
        break;
      case 'motivo':
        if (this.props.motivosNaoCumprimento.length === 0) {
          requestMotivos(this.failCallback);
        }
        break;
      default:
        break;
    }
  }

  buscaDadosDeDominio = () => {
    if (this.props.motivosNaoCumprimento.length === 0) {
      this.doRequest('motivo');
      return null;
    }
    return null;
  }

  retornaTamanhoExigencias = () => {
    let colecao = [];
    if (this.props.requerimento.exigencias) {
      colecao = this.props.requerimento.exigencias
        .filter(exigencia => (!tiposExigenciaSistema.includes(exigencia.tipo)));
    }
    return colecao.length;
  }

  handleChange = (e, name) => {
    this.setState({
      [name]: e.value,
    });
  }

  handleChangeFile = (file) => {
    this.setState({
      document: file,
    });
  }

  addArquivo = () => {
    const { documents } = this.state;
    if (!documents || documents.length === 0) {
      return;
    }
    const arquivosAdicionados = [];
    const { requerimento } = { ...this.state };
    documents.forEach((documentoAtual) => {
      let arquivo = {};
      arquivo = {
        documento: this.state.document,
        protocolo: requerimento.protocolo,
        tipoDocumento: this.state.tipoDocumento,
      };
      this.state.arquivo.documento = documentoAtual;
      this.state.arquivo.protocolo = arquivo.protocolo;
      this.state.arquivo.tipoDocumento = arquivo.tipoDocumento;
      arquivosAdicionados.push(arquivo);
      this.props.addArquivo(this.state.arquivo, this.props.arquivo);
    });
  }

  modalEncerramentoExigenciaContent = () => (
    <React.Fragment>
      {/* ÁREA COM SCROLL */}
      <div
        style={{
          maxHeight: '50vh',
          overflowY: 'auto',
          overflowX: 'hidden',
          paddingRight: '10px',
        }}
      >
        <div className="row">
          <Grid cols="12 12 12 12">
            <ListaEncerramentoExigencias
              exigencias={this.filtraExigencias()}
              motivosNaoCumprimento={this.props.motivosNaoCumprimento}
              handlePositionalChange={this.handlePositionalChange}
              handleChangeFile={this.handleChangeFile}
            />
          </Grid>
        </div>
      </div>

      {/* ÁREA FIXA */}
      <div>
        <DataGridCustom
          title=""
          retirarLinhaSeparadora={false}
          cssLinha="header-com-linha-exigencia"
        />

        <ul>
          <div className="row">
            <p>
              <b>
                Se desejar, anexe um documento para justificar o encerramento.
              </b>
            </p>
          </div>

          <div className="row">
            <Grid cols="8 8 8 8">
              <Input
                label="Tipo de documento"
                number
                placeholder="Selecione o tipo de documento"
                onChange={e => this.handleChange(e, 'tipoDocumento')}
                value={this.state.tipoDocumento}
                itemList={this.state.tiposDisponiveis}
                custom
              />
            </Grid>
          </div>
          <UploadDragDrop
            files={this.state.document ? [this.state.document] : []}
            // onChange={documents => this.setState({ documents })}
            // files={this.state.document ? [this.state.document] : []}
            onChange={documents => this.setState({ documents, document: documents[0] || null })}
            onSelect={document => this.handleChangeFile(document)}
            multiple={false}
            accept="application/pdf,.pdf"
            minHeight={70}
            titulo="Arraste o arquivo PDF aqui"
            subtitulo="ou clique para selecionar"
            largura="8"
            disabled={!this.state.tipoDocumento}
          />
        </ul>
      </div>
    </React.Fragment>
  );

  // modalEncerramentoExigenciaContent = () => (
  //   <React.Fragment>
  //     <div
  //       style={{
  //         maxHeight: '70vh',
  //         overflowY: 'auto',
  //         overflowX: 'hidden',
  //         paddingRight: '10px',
  //       }}
  //     >
  //       <div className="row">
  //         <Grid cols="12 12 12 12">
  //           <ListaEncerramentoExigencias
  //             exigencias={this.filtraExigencias()}
  //             motivosNaoCumprimento={this.props.motivosNaoCumprimento}
  //             handlePositionalChange={this.handlePositionalChange}
  //             handleChangeFile={this.handleChangeFile}
  //           />
  //         </Grid>
  //       </div>
  //       <DataGridCustom title="" retirarLinhaSeparadora={false} cssLinha="header-com-linha-exigencia" />
  //       <ul>
  //         <div className="row">
  //           <p><b>Se desejar, anexe um documento para justificar o encerramento.</b></p>
  //         </div>
  //         <div className="row">
  //           <Grid cols="8 8 8 8">
  //             <Input
  //               label="Tipo de documento"
  //               number
  //               placeholder="Selecione o tipo de documento"
  //               onChange={e => this.handleChange(e, 'tipoDocumento')}
  //               value={this.state.tipoDocumento}
  //               itemList={this.state.tiposDisponiveis}
  //               custom
  //             />
  //           </Grid>
  //         </div>
  //         <UploadDragDrop
  //           files={this.state.documents}
  //           onChange={documents => this.setState({ documents })}
  //           multiple={false}
  //           accept="application/pdf,.pdf"
  //           minHeight={70}
  //           titulo="Arraste o arquivo PDF aqui"
  //           subtitulo="ou clique para selecionar"
  //           largura="8"
  //         />
  //       </ul>
  //     </div>
  //   </React.Fragment>
  // )

  formularioProntoParaEnvio = () => {
    const possuiTipoDocumento = (this.state.tipoDocumento !== undefined && this.state.tipoDocumento !== null && this.state.tipoDocumento !== '');
    const possuiDocumentoUpload = (this.state.document !== null);
    if ((possuiTipoDocumento && possuiDocumentoUpload)) {
      return false;
    } else if (possuiTipoDocumento && !possuiDocumentoUpload) {
      return true;
    } else if (!possuiTipoDocumento && possuiDocumentoUpload) {
      return false;
    }
    return false;
  }

  modalEncerramentoExigenciaFooter = () => (
    <React.Fragment>
      <div className="right">
        <Button
          disabled={this.formularioProntoParaEnvio()}
          className="dtp-primary"
          hint="Encerrar exigências do requerimento"
          onClick={this.handleSave}
          title="Encerrar exigências"
        />
      </div>
    </React.Fragment>
  )

  handleClose = () => {
    this.props.handleModal('showEncerramentoExigenciaModal');
  }

  render() {
    return (
      <Modal
        {...this.props}
        conteudofooter={this.modalEncerramentoExigenciaFooter()}
        conteudomodal={this.modalEncerramentoExigenciaContent()}
        onHide={this.handleClose}
        size="lg"
        showModal
        title="Exigências não Atendidas"
      />
    );
  }
}

ModalEncerramentoExigencia.propTypes = {
  requerimento: PropTypes.shape({
    exigencias: PropTypes.array,
  }),
  showModal: PropTypes.func,
  handleModal: PropTypes.func,
  handleEncerramentoExigenciaSent: PropTypes.func,
  handleModalComposto: PropTypes.func,
  motivosNaoCumprimento: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  })),
  addArquivo: PropTypes.func,
}.isRequired;

ModalEncerramentoExigencia.defaultProps = {
  motivosNaoCumprimento: [],
  tiposDocumentos: [],
};

const mapStateToProps = state => ({
  motivosNaoCumprimento: state.base.motivosNaoCumprimento,
  tiposDocumentos: state.base.tiposDocumentos,
});

export default connect(mapStateToProps)(ModalEncerramentoExigencia);




// WEBPACK FOOTER //
// ./src/pages/consultas/Exigencia/ModalEncerramentoExigencia.jsx